export default __webpack_public_path__ + "static/media/simbolo-light.50f80d2e.png";